import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/Hero";
import { MarqueeStrip } from "@/components/Marquee";
import { Gallery } from "@/components/Gallery";
import { FAQ } from "@/components/FAQ";
import { Navbar } from "@/components/Navbar";
import { QuoteForm } from "@/components/QuoteForm";
import { Reviews } from "@/components/Reviews";
import { Services } from "@/components/Services";
import { WhatsAppButton } from "@/components/WhatsAppButton";

export default function Home() {
  return (
    <div className="site">
      <Navbar />
      <main>
        <Hero />
        <MarqueeStrip />
        <Services />
        <QuoteForm />
        <Reviews />
        <Gallery />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
